import { useHistory } from "react-router-dom";
import HeaderReportMp from "../../../../Components/ComponentsMarketplace/HeaderReportMp";
import BootonsMap from "../../../../Components/ComponentsMarketplace/ButtonsMap";
import { useCutChicken } from "../../../../providers/CutChickenContext"
import { useState, useEffect } from "react";

import {
  Container,
  SizeContainer,
  ContainerCard,
  InternalMenu,
  Confirm
} from "./style";

const MpStockChickenCut = () => {
  const history = useHistory()

  const { infoCutChicken, stockCutChickenMarket, getCutChickenStockMp } = useCutChicken()

  const [ quantidade, setQuantidade ] = useState(0),
  [ preco, setPreco ] = useState(0)
  useEffect(() => {
    
    setPreco(infoCutChicken?.custoUnitario)
    setQuantidade(stockCutChickenMarket)  
  },[infoCutChicken, stockCutChickenMarket])

  useEffect(() => {

    getCutChickenStockMp()

  }, [])

  return (
    <Container>
      <SizeContainer>
        <HeaderReportMp title="Estoque" pathImg="./images/stock_Mp.svg" />
        <InternalMenu>
          <button onClick={() => history.push('/mpStockSausage')} ><img  src="./images/sausage_orange.svg" alt="sausage"/></button>
          <button onClick={() => history.push('/mpStockChicken')}><img src="./images/chicken_orange.svg" alt="chicken"/></button>
          <button className='selected'><img src="./images/chicken_cut_orange.svg" alt="chicken cut"/></button>
          <button onClick={() => history.push('/mpStockFries')}><img src="./images/fries_orange.svg" alt="fries"/></button>
        </InternalMenu>
        <ContainerCard>
          <div>
            <p>Quantidade</p>
            <small>{quantidade}</small>
          </div>
          <p>X</p>
          <div>
            <p>Custo médio</p>
            <small>{preco}</small>
          </div>
          <div>
            <p>Valor do estoque</p>
            <small>{preco*quantidade}</small>
          </div>
        </ContainerCard>
        <BootonsMap />
        <Confirm>Comprar</Confirm>
      </SizeContainer>
    </Container>
  );
};
export default MpStockChickenCut;
